import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, TextField, IconButton} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
// import InputField from './InputField';
// import DatePicker from './DatePicker';
// import DropDown from './DropDown';
import Toggle from './Toggle';
import { SchoolRounded } from '@material-ui/icons';
// import * as Calc from '../services/CalcService';
import moment from 'moment';
import QualificationsSubform from './QualificationsSubform';


export default class Qualifications extends Component {

    constructor(props) {
        super(props);
        this.reset_state = {
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            editing: false,
            error: false,
            error_message: '',
            querying: true,
            search_name: '',
            search_number: '',
            search_branch: '',
            search_rom: '',
            has_searched: false,
            users_array: [],
            show_dialogue: false,
            form_view: false,
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Create Employee',
            id_validation: false,
            id_validation_gender: '',
            write_successful: false,
            write_success_message: '',
        }
        this.state = {  //Note: designations not reset
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            editing: false,
            designations: [],
            error: false,
            error_message: '',
            querying: true,
            search_name: '',
            search_number: '',
            search_branch: '',
            search_rom: '',
            has_searched: false,
            users_array: [],
            show_dialogue: false,
            form_view: false,
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Create Employee',
            include_terminated_users: false,
            id_validation: false,
            id_validation_gender: '',
            write_successful: false,
            write_success_message: '',
        };
        this.datasheetFieldSpecs = [
            { field: 'qualifications', headerName: 'Qualifications', width: 73, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.showQualsSub(parms)} 
                >
                    <SchoolRounded/>
                </IconButton>
            )},
            { field: 'employee_number', headerName: 'Empl.#', width: 110, align:'center',headerAlign:'center'},     
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'id', headerName: 'ID Number', width: 130},
            { field: 'gender', headerName: 'Gender', width: 110, align:'center',headerAlign:'center'},
            { field: 'race', headerName: 'Race', width: 110, align:'center',headerAlign:'center'},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'store_code', headerName: 'Branch', width: 110, align:'center',headerAlign:'center'},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125},
            { field: 'store', headerName: 'Store', width: 160},
            { field: 'region', headerName: 'Region', width: 150},
            { field: 'registered', headerName: 'Registered?', width: 110, align:'center',headerAlign:'center'},
            { field: 'is_a_rom', headerName: 'Manager?', width: 110, align:'center',headerAlign:'center'},
            { field: 'is_an_exec', headerName: 'Exec?', width: 110, align:'center',headerAlign:'center'},
            { field: 'terminated', headerName: 'Terminated?', width: 110, align:'center',headerAlign:'center'},
            { field: 'email', headerName: 'Email', width: 200},
        ]

        this.input_fieldSpecs = [

            {field: "name", headerName: "Employee Name (SURNAME INITIALS)", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 4, f_maxLength: 100, f_upperCase:true},

            {field: "employee_number", headerName: "Employee Number", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 4, f_maxLength: 10,f_upperCase:true},

            {field: "id", headerName: "ID Number", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 4, f_maxLength: 20, f_upperCase:true},

            {field: "gender", headerName: "Gender", f_inputType:'dropdown', f_show:true, f_required:true},

            {field: "race", headerName: "Race", f_inputType:'dropdown', f_show:true, f_required:true},

            {field: "job_title", headerName: "Job Title", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 4, f_maxLength: 50, f_upperCase:true},

            {field: "date_of_entry", headerName: "Date of Entry?", f_inputType:'datepicker', f_required:true, f_show:true},

            {field: "store_code", headerName: "Branch Code", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 4, f_maxLength: 3, f_upperCase:true},

            {field: "reports_to_rom", headerName: "Manager Code", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 4, f_maxLength: 5, f_upperCase:true},

            {field: "store", headerName: "Store", f_inputType:'text', f_show:true, f_required:false,  f_minLength: 4, f_maxLength: 100, f_upperCase:true},

            {field: "region", headerName: "Region", f_inputType:'text', f_show:true, f_required:false,  f_minLength: 4, f_maxLength: 50, f_upperCase:true},
           
            {field: "is_exec", headerName: "Executive?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true},

            {field: "employment_terminated", headerName: "Terminated?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true},

        ]

        this.genders = [{id:'M',gender:'Male'},{id:'F',gender:'Female'}]
        this.races = [{id:'A',race:'African'},{id:'C',race:'Coloured'},{id:'I',race:'Indian'},{id:'W',race:'White'}]

        this.Today = new Date();

    }

    componentDidMount = () => {
        // if (this.state.search_name||this.state.search_number||this.state.search_branch||this.state.search_rom){
        //     this.runSearch();
        // }
    };

    runSearch = (e) => {

        if (e){e.preventDefault()};
        // console.log('e :>> ', e);

        if (!this.state.search_name&&!this.state.search_number&&!this.state.search_branch&&!this.state.search_rom){return}

        this.setState({searching:true, querying:true, search_ready:false,users_array:[], has_searched:true});

        var params = {search_string: this.state.search_name, search_type:'surname', incl_terminated: this.state.include_terminated_users};
        if (this.state.search_number){params={search_string: this.state.search_number, search_type:'employee number', incl_terminated: this.state.include_terminated_users}}
        if (this.state.search_branch){params={search_string: this.state.search_branch, search_type:'branch', incl_terminated: this.state.include_terminated_users}}
        if (this.state.search_rom){params={search_string: this.state.search_rom, search_type:'rom', incl_terminated: this.state.include_terminated_users}}

        Gserv.sendCommand('find_users_for_maintenance',this.props.gwt,params)
        .then(reply => {
            // console.log('search reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (find_users_for_maintenance) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (find_users_for_maintenance) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({error:true,error_message:"No employee records found matching the search.",searching:false, has_searched:false});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."})
                }
            } else {
                if (reply.Records){
                    let record_array = reply.Records;
                    let DOE = null;
                    for (var i=0;i<record_array.length;i++){
                        DOE = new moment(record_array[i].date_of_entry).format("YYYY-MM-DD");
                        record_array[i].date_of_entry = DOE;
                    }
                }
                this.setState({users_array:reply.Records,searching:false,search_ready:true, querying:false});
            }
        });
    }

    handleChildStateUpdate = (new_state) => {
        this.setState(new_state);
    }

    showQualsSub = (parms) => {
        // console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row,form_view:true});
    }
    
    handleToggleChange = (e) => {
        // console.log('e :>> ', e);
        switch (e.field) {
            case 'include_terminated_users':
                this.setState({include_terminated_users:e.value});
                // if (this.state.search_ready){
                    // this.runSearch();
                // }
                break;
        
            default:
                break;
        }
    }

    parseID = (idNumber) => {
    
        //Kill at source if not 13 digits or not all numbers...
        if (idNumber.length !== 13 || isNaN(idNumber)){
            return {Result : "Failed"};
        }

        // assume everything is correct and if it later turns out not to be, set this to false
        var correct = true;
        var idParse = {};
    
        // get first 6 digits as a valid date
        var tempDate = new Date(idNumber.substring(0, 2), idNumber.substring(2, 4)-1, idNumber.substring(4, 6));
        var id_date = tempDate.getDate();
        var id_month = tempDate.getMonth();
      
        var id_year = tempDate.getFullYear();
        const thisYear = this.Today.getFullYear();
    
        if((thisYear - id_year)>=100){
          tempDate.setFullYear(tempDate.getFullYear()+100);
          id_year = tempDate.getFullYear()
        }
    
        // eslint-disable-next-line eqeqeq
        if (!((tempDate.getFullYear().toString().substring(2,4) == idNumber.substring(0, 2)) && (id_month == idNumber.substring(2, 4) - 1) && (id_date == idNumber.substring(4, 6)))) {
            // console.log('Date failed');
            correct = false;
        }
    
        // get the gender
        var genderCode = idNumber.substring(6, 10);
        var gender = parseInt(genderCode) < 5000 ? "F" : "M";
    
        // get country ID for citzenship
        var citzenship = parseInt(idNumber.substring(10, 11)) === 0 ? "Yes" : "No";
    
        // apply Luhn formula for check-digits
        var tempTotal = 0;
        var checkSum = 0;
        var multiplier = 1;
        for (var i = 0; i < 13; ++i) {
            tempTotal = parseInt(idNumber.charAt(i)) * multiplier;
            if (tempTotal > 9) {
                tempTotal = parseInt(tempTotal.toString().charAt(0)) + parseInt(tempTotal.toString().charAt(1));
            }
            checkSum = checkSum + tempTotal;
            multiplier = (multiplier % 2 === 0) ? 1 : 2;
        }
        if ((checkSum % 10) !== 0) {
            correct = false;
        };
    
        //advance DOB by 12 hours to eliminate issue with timezones...
        tempDate.setHours(tempDate.getHours()+12);
    
        // if no error found, hide the error message
        if (correct) {
            idParse = {
              id_number : idNumber,
              Result : "Success",
              date_of_birth : tempDate,
              gender : gender,
              sa_citizen : citzenship
            };
        }
        // otherwise, show the error
        else {
            idParse = {
              Result : "Failed"        
            };
        }
        return idParse;
    }

    resetMe = () => {
        this.setState(this.reset_state);
    }

    editAgain = () => {
        this.setState({error:false,error_message:'',writing:false,});
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                // style={{backgroundColor:'yellow'}}
            >
                {!this.state.assessments_view&&
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        // height:'22vh',
                        // maxWidth:680,
                        // minWidth:680
                        width:1250
                    }}
                >
                   <Typography
                    color='primary'
                    style={{paddingTop:15, paddingBottom:15}}
                   >
                       Maintain Employee Qualifications
                   </Typography>
                   
                </Paper>
                </Grid>}


                {/* {this.state.querying&&
                <Grid item>
                    <br/>
                    <Settings className='icn-spinner' /> Querying...
                </Grid>} */}

                {!this.state.form_view&&
                <form onSubmit={this.runSearch}>

                    <Grid 
                        container 
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        style={{padding:'10px'}}
                    >

                        <TextField
                            id='surname'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={true}
                            label={'Surname Search'}
                            variant='outlined'
                            value={this.state.search_name}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^ A-Za-z]+/g, '').toUpperCase();
                                const can_sub = (outText.length>2);
                                this.setState({search_name: outText, search_number: '',search_branch:'', search_rom:'', search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px',marginTop:'15px'}}
                            disabled={this.state.searching||this.state.error}
                        />

                        <TextField
                            id='emplNum'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={false}
                            label={'Employee # Search'}
                            variant='outlined'
                            value={this.state.search_number}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^ A-Za-z0-9]+/g, '').toUpperCase();
                                const can_sub = (outText.length>2);
                                this.setState({search_number: outText, search_name:"", search_branch:"", search_rom:"", search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px', marginTop: '15px', marginLeft:'10px'}}
                            disabled={this.state.searching}
                        />

                        <TextField
                            id='branchCode'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={false}
                            label={'Branch Code Search'}
                            variant='outlined'
                            value={this.state.search_branch}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^A-Za-z]+/g, '').toUpperCase();
                                const can_sub = (outText.length>2);
                                this.setState({search_branch:outText, search_name: '', search_number: '', search_rom:'', search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px',marginTop:'15px', marginLeft:'10px'}}
                            disabled={this.state.searching||this.state.error}
                        />

                        <TextField
                            id='romCode'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={false}
                            label={'Manager Code Search'}
                            variant='outlined'
                            value={this.state.search_rom}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^A-Za-z]+/g, '').toUpperCase();
                                const can_sub = (outText.length>1);
                                this.setState({search_rom:outText, search_name: '', search_number: '', search_branch:'', search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px',marginTop:'15px', marginLeft:'10px'}}
                            disabled={this.state.searching||this.state.error}
                        />
                        &nbsp;&nbsp;&nbsp;    
                        <Toggle 
                            fieldMap={{field: "include_terminated_users", headerName: "Incl. Terminated Employees?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                            setField={this.handleToggleChange}
                            // disabled={}
                        />

                    </Grid>

                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        style={{marginLeft:'10px',marginBottom:'15px'}}
                        disabled={!this.state.search_ready}
                    >
                        Search
                    </Button>

                </form>}

                {/* Datagrid goes here */}
                {!this.state.form_view&&this.state.has_searched&&
                <DatasheetView 
                    dataset={this.state.users_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    // handleDelete={this.handleDelete}
                    // handleEdit={this.handleUpdate}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={8}
                />}

                {this.state.error&&!this.state.form_view&&
                <div>
                    <Typography color='secondary' style={{Width:1250,maxWidth:1250, textAlign:'center',marginTop:15}}>{this.state.error_message}</Typography><br/>
                    <Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>
                </div>}

                {this.state.form_view&&
                <Paper
                    elevation={3}
                    style={{paddingBottom:'15px', paddingTop:'15px'}}
                    
                >
                    <Grid
                        container
                        direction='column'
                        justifyContent='center'
                        alignContent='center'
                        // style={{backgroundColor:'yellow'}}
                    >

                        <QualificationsSubform 
                            employee={this.state.current_record}
                            gwt={this.props.gwt}
                            setParentState={this.handleChildStateUpdate}
                        />

                    </Grid>
                    
                </Paper>}

            </Grid>
        );
    }
    
}